/* eslint-disable react/jsx-key */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useEffect, useCallback } from 'react'
import { DatePicker, Spin, Icon } from 'antd'
import { getCard99, lockCard99Data } from 'api/pgads'
import { HeaderTag } from './Card99EditAntd'
import moment from 'moment'
import { UtilityUnitSelection } from 'core'
import { List } from 'immutable-ext'
import Task from 'data.task'
import { LockCheckFunc } from '../../Card95Antd'
const InsertHeader = ({
  apiTargetInfo,
  // utilityNameMap,
  // unitNameMap,
  // utilityUnitMap,
  handleChange,
  state,
  setInsertData,
  // card99Extend,
  // headers,
  mode,
  setMode,
  setError,
  setLoading,
  setShowEditDialog,
  spinning,
  dataModified = false,
  clearData,
  // eslint-disable-next-line no-unused-vars
  isAdmin,
  disableComp,
  ...prop
}) => {
  const insertDate = moment().endOf('month')
  const {
    utility,
    unit,
    year = prop.year || parseInt(insertDate.format('YYYY')),
    month = prop.month || parseInt(insertDate.format('MM')),
  } = state

  insertDate.month(month - 1).year(year)

  const onRetrieveData = useCallback(
    _ => {
      if (
        utility === undefined ||
        unit === undefined ||
        utility == null ||
        unit == null ||
        mode === 'D' ||
        mode === 'V'
      ) {
        return
      }

      setLoading(true)

      List.of(
        getCard99(apiTargetInfo)(year, month, utility, [unit]),
        lockCard99Data(apiTargetInfo)({
          year: year,
          month: month,
          units: [unit],
          endYear: year,
          endMonth: month,
        })
      )
        .traverse(Task.of, _ => _)
        .fork(
          e => setError(e, setShowEditDialog),
          dataList => {
            setLoading(false)
            const data = dataList.get(0)
            const lockData = dataList.get(1)
            const lockStatus = LockCheckFunc(
              lockData,
              data[0] || { year, month, unit, utility }
            ) || {
              lock: 'U',
            }

            if (data.length > 0) {
              clearData()
              setInsertData({ ...data[0], lock: lockStatus.lock })
              setMode('E')
            } else {
              clearData()
              handleChange(
                { target: { name: 'lock', value: lockStatus.lock } },
                false
              )
              handleChange(
                {
                  target: {
                    name: 'loadData',
                    value: {
                      utility,
                      unit,
                      year,
                      month,
                      lock: lockStatus.lock,
                    },
                  },
                },
                false
              )
              setMode('N')
            }
          }
        )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      apiTargetInfo,
      clearData,
      handleChange,
      // mode,
      month,
      setError,
      setInsertData,
      setLoading,
      setMode,
      setShowEditDialog,
      unit,
      utility,
      year,
    ]
  )

  useEffect(onRetrieveData, [onRetrieveData])

  return (
    <Spin spinning={spinning} indicator={<React.Fragment />}>
      <HeaderTag
        style={{
          verticalAlign: 'middle',
          alignSelf: 'center',
          gridColumnEnd: 'span 4',
          textAlign: 'center',
        }}
      >
        {mode === 'D' ? (
          <span>
            {disableComp && <Icon type="lock" />} {'  '}Delete Data
          </span>
        ) : mode === 'N' ? (
          <span>
            {disableComp && <Icon type="lock" />} {'  '}New Data
          </span>
        ) : mode === 'E' ? (
          <span>
            {disableComp && <Icon type="lock" />} {'  '} Edit Data
          </span>
        ) : (
          'View Data'
        )}
      </HeaderTag>
      <div
        style={{
          justifyContent: 'space-around',
          backgroundColor: '#e6f7ff',
          display: 'grid',
          gridTemplateColumns: '2fr 12fr 2fr 5fr',
          gridColumnGap: '15px',
          padding: '0px 5px 5px',
        }}
      >
        <div style={{ padding: '10px 0px 0px', gridColumnEnd: 'span 2' }}>
          Utility / Unit
        </div>
        <div style={{ padding: '10px 0px 0px', gridColumnEnd: 'span 2' }}>
          Month
        </div>

        <UtilityUnitSelection
          defaultValue={[utility, unit]}
          utility={utility}
          unit={unit}
          onUnitChange={value => {
            handleChange(
              { target: { name: 'utility', value: value[0] } },
              false
            )
            handleChange({ target: { name: 'unit', value: value[1] } }, false)
          }}
          style={{ gridColumnEnd: 'span 2' }}
          disabled={mode === 'D' || mode === 'V' || dataModified}
        />

        <DatePicker.MonthPicker
          style={{ alignSelf: 'center', gridColumnEnd: 'span 2' }}
          format="MMMM-YYYY"
          allowClear={false}
          value={insertDate}
          onChange={date => {
            handleChange(
              {
                target: { name: 'year', value: parseInt(date.format('YYYY')) },
              },
              false
            )
            handleChange(
              {
                target: { name: 'month', value: parseInt(date.format('MM')) },
              },
              false
            )
            // handleChange({ target: { name: 'insertDate', value: date } }, false)
          }}
          disabled={mode === 'D' || mode === 'V' || dataModified}
        />
      </div>
    </Spin>
  )
}

export default InsertHeader
